export const MOV_FILTER_QUERY_PARAM = "mov" as const;
